import React, { useEffect } from "react";
import DataTable from "./DataTable";
import moment from "moment";
import { Icons } from "../constants/icon-library";
import { useDispatch, useSelector } from "react-redux";
import { confirmAndDelete } from "./constants";
import { getAllParticipants, removeParticipant } from "../features/admin/adminSlice";

function Participants() {
  const dispatch = useDispatch();
  const { participants = [] } = useSelector((state) => state.admin);

  const handleRemove = (uuid) => {
    confirmAndDelete({
      uuid,
      dispatch,
      deleteThunk: removeParticipant,
      successMessage: "Participant removed successfully.",
      errorMessage: "Failed to remove participant.",
    });
  };
  useEffect(() => {
    dispatch(getAllParticipants());
  }, [dispatch]);

  const columns = [
    { label: "Name", key: "name" },
    { label: "Email/Username", key: "email" },
    { label: "Platform", key: "platform" },
    { label: "Account Name", key: "userId.name" },
    { label: "Account Email", key: "userId.email" },
    { label: "Created At", key: "createdAt" },
    { label: "Action", key: "action" },
  ];

  const rowRenderer = (p) => (
    <tr key={p.uuid}>
      <td className="align-middle ps-3">{p?.name}</td>

      <td className="align-middle ps-3">{p?.email || p?.username}</td>

      <td className="align-middle ps-3">{p?.platform}</td>
      <td className="align-middle ps-3">{p?.userId?.name}</td>
      <td className="align-middle ps-3">{p?.userId?.email}</td>
      <td className="align-middle ps-3">
        {moment.utc(p.createdAt).format("MMM D, YYYY • h:mm A")}
      </td>

      <td className="align-middle text-end">
        <button
          className="btn btn-sm text-danger"
          title="Delete"
          onClick={() => handleRemove(p.uuid)}
        >
          <i
            className={`wb ${Icons("delete")} fs-8 me-2 mt-3 align-middle`}
          ></i>
        </button>
      </td>
    </tr>
  );

  return (
    <div className="content">
      <div className="row">
        <div className="col-12">
          <DataTable
            title="Participants"
            data={participants}
            columns={columns}
            rowRenderer={rowRenderer}
          />
        </div>
      </div>
    </div>
  );
}

export default Participants;
